import { useEffect, useState } from "react";
import API from "../api";
import { useParams, useNavigate } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";

export default function OrderDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState({});
  const [users, setUsers] = useState([]);
  const { showLoader, hideLoader, showSuccess } = useLoader();


  const token = localStorage.getItem("token");
  let payload = null;
  let role = null;
  let self_id = null;
  if (token) {
    try {
      payload = JSON.parse(atob(token.split(".")[1]));
      role = payload.role
      self_id = payload.id
    } catch { }
  }

  const links = {
    "expressone": "https://tracking.expressone.hu/?plc_number=",
    "gls": "https://gls-group.eu/HU/hu/csomagkovetes?match=",
    "dpd": "https://www.dpdgroup.com/hu/mydpd/my-parcels/incoming?parcelNumber=",
    "mpl": "https://www.posta.hu/ugyfelszolgalat/nyomkovetes?ids=",
    "foxpost": "https://foxpost.hu/csomagkovetes/?code=",
    "alza": null,
    "packeta": "https://tracking.packeta.com/hu/",
    "sameday": "https://sameday.hu/#awb="
  }

  const shipment_method_image_urls = {
    "hazhozszallitas": "../images/shipment_metod/hazhozszallitas.png",
    "csomagautomata": "../images/shipment_metod/csomagautomata.png",
    "szemelyes_atvetel": "../images/shipment_metod/szemelyes.png"
  }
  useEffect(() => {
    const loadData = async () => {
      showLoader("Betöltés...");

      const orderRes = await API.get(`/orders/${id}`);
      setOrder(orderRes.data);

      const usersRes = await API.get("/users/dropdown");
      setUsers(usersRes.data);

      hideLoader();

    };

    loadData();
  }, [id]);

  const save = async () => {
    showLoader("Mentés...");

    await API.put(`/orders/${id}`, order);

    showSuccess("Mentve");

    setTimeout(() => {
      window.location.reload();
    }, 400);
  };


  const handleDeleteItem = async () => {
    if (window.confirm("Biztosan törlöd ezt a rendelést?")) {
      showLoader("Törlés...");
      await API.delete(`/orders/${id}`);
      showSuccess("Törölve");
      setTimeout(() => {
        hideLoader(0);
        navigate("/");
      }, 800);
    }
  };

  const handleRestoreItem = async () => {
    if (window.confirm("Biztosan visszaállítod ezt a rendelést?")) {
      showLoader("Visszaállítás...");
      await API.put(`/orders/${id}/restore`);
      showSuccess("Visszaállítva");
      setTimeout(() => { window.location.reload(); }, 800);
    }
  };

  const handleFullDelete = async () => {
    if (window.confirm("Véglegesen törölni akarod ezt a rendelést? Ez a művelet NEM visszavonható!")) {
      showLoader("Végleges törlés...");

      await API.delete(`/orders/${id}/force`);

      showSuccess("Végleg törölve");

      setTimeout(() => {
        hideLoader(0);
        navigate("/");
      }, 800);
    }
  };


  const handleArrivedItem = async () => {
    const updatedOrder = {
      ...order,
      arrived: true,
      completed_date: new Date().toISOString().slice(0, 10)
    };

    showLoader("Frissítés...");

    await API.put(`/orders/${id}`, updatedOrder);

    showSuccess("Frissítve");

    setTimeout(() => {
      hideLoader(0);
      window.location.reload();
    }, 800);
  };


  const handleNotArrivedItem = async () => {
    const updatedOrder = {
      ...order,
      arrived: false,
      completed_date: null
    };

    showLoader("Frissítés...");

    await API.put(`/orders/${id}`, updatedOrder);

    showSuccess("Frissítve");

    setTimeout(() => {
      window.location.reload();
    }, 800);
  };


  return (
    <>
      <div className="p-6">
        <button
          className="bg-gray-300 text-black px-3 py-1 ml-2"
          onClick={() => navigate("/")}
        >
          ← Vissza
        </button>
        <button
          className="bg-blue-500 text-white px-3 py-1 ml-2"
          onClick={() => save()}
        >
          Mentés
        </button>
        {order.deleted ? (
          <>
            <button
              className="bg-green-500 text-white px-3 py-1 ml-2"
              onClick={() => handleRestoreItem(order.id)} // Define this function for restoring the item
            >
              Visszaállítás
            </button>
          </>
        ) : (
          <button
            className="bg-red-500 text-white px-3 py-1 ml-2"
            onClick={() => handleDeleteItem(order.id)}
          >
            Törlés
          </button>
        )}
      </div>
      <div className="p-6 justify-self-center w-full max-w-[400px]">


        {order.deleted ? (
          <h2 className="text-2xl mb-4">Rendelés részletei - <span className="text-red-500">Törölt</span></h2>
        ) : (
          <h2 className="text-2xl mb-4">Rendelés részletei</h2>
        )}

        {role === "admin" ? (
          <h3 className="text-s text-blue-500 mb-4">({order.display_name ? order.display_name : order.username} rendelése)</h3>
        ) : (
          <>
            {order.contributor_id === self_id ? (
              <h3 className="text-s text-gray-500 mb-4">🔗 Megosztva veled. ({order.creators_display_name ? order.creators_display_name : order.creators_username} rendelése)</h3>
            ) : (
              <></>
            )}
          </>
        )}

        <label htmlFor="order_name">Termék neve:</label>
        <input
          id="order_name"
          className="border p-2 mb-2 block w-full"
          value={order.secret && role === 'admin' ? "Titkos rendelés" : order.product || ""}
          onChange={(e) => {
            if (order.secret && role === "admin") {
              return
            }
            else {
              setOrder({ ...order, product: e.target.value });
            }
          }}
        />


        <div className="my-4">
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              id="secret"
              type="checkbox"
              className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
              checked={!!order.secret}
              disabled={role === 'admin'}
              onChange={(e) => {
                  setOrder({ ...order, secret: e.target.checked });
              }}
            />
            <span className="text-gray-700">Titkos rendelés</span>
          </label>
        </div>

        <label htmlFor="shop">Bolt neve:</label>
        <input
          id='shop'
          className="border p-2 mb-2 block w-full"
          value={order.secret && role === 'admin' ? "Titkos rendelés" : order.shop || ""}
          onChange={(e) => {
            if (order.secret && role === "admin") {
              return
            }
            else {
              setOrder({ ...order, shop: e.target.value });
            }
          }}
        />

        <label htmlFor="price">Ár:</label>
        <input
          type="number"
          id='price'
          min={0}
          className="border p-2 mb-2 block w-full"
          value={order.secret && role === 'admin' ? "" : order.price || ""}
          onChange={(e) => {
            if (order.secret && role === "admin") {
              return
            }
            else {
              setOrder({ ...order, price: e.target.value });
            }
          }}
        />

        <label htmlFor="fizetes" className="block mb-2">Fizetés módja:</label>
        <select
          id='fizetes'
          className="border p-2 mb-2 block w-full"
          value={order.payment_method || ""}
          onChange={(e) =>
            setOrder({ ...order, payment_method: e.target.value, })
          }
        >
          <option value="">-- Nincs megadva --</option>
          <option value="Utánvét">Utánvét</option>
          <option value="Előre utalás">Előre utalás</option>
          <option value="Kártyás vásárlás">Kártyás vásárlás</option>
        </select>

        <label htmlFor="szallitas" className="block mb-2">Szállitás módja:</label>
        <div className="flex">
          <select
            id='szallitas'
            className={`border p-2 mb-2 block ${order.shipping_method ? "w-5/6" : "w-full"}`}
            value={order.shipping_method || ""}
            onChange={(e) =>
              setOrder({ ...order, shipping_method: e.target.value, })
            }
          >
            <option value="">-- Nincs megadva --</option>
            <option value="hazhozszallitas">Házhozszállítás</option>
            <option value="csomagautomata">Csomagautomata</option>
            <option value="szemelyes_atvetel">Személyes átvétel</option>
          </select>
          {order.shipping_method ? (
            <span className="w-1/6 p-2 mb-2">
              <img src={shipment_method_image_urls[order.shipping_method]} alt={shipment_method_image_urls[order.shipping_method]} className="w-[32px] float-right" />
            </span>
          ) : null}
        </div>

        <label htmlFor="shipment_location">Átvétel helyszíne:</label>
        <input
          id='shipment_location'
          className="border p-2 mb-2 block w-full"
          value={order.shipment_location || ""}
          onChange={(e) => setOrder({ ...order, shipment_location: e.target.value })}
        />

        <label htmlFor="futarceg" className="block mb-2">Futárszolgálat:</label>
        <select
          id='futarceg'
          className="border p-2 mb-2 block w-full"
          value={order.shipping_company || ""}
          onChange={(e) =>
            setOrder({ ...order, shipping_company: e.target.value, })
          }
        >
          <option value="">-- Nincs megadva --</option>
          <option value="gls">GLS</option>
          <option value="foxpost">Foxpost</option>
          <option value="dpd">DPD</option>
          <option value="alza">Alza</option>
          <option value="expressone">Express One</option>
          <option value="mpl">MPL</option>
          <option value="packeta">Packeta (Z-Box)</option>
          <option value="sameday">Sameday</option>
        </select>

        <label htmlFor="packagenumber">Csomagszám:</label>
        <div className="flex">
          <input
            id='packagenumber'
            //className="border p-2 mb-2 block w-5/6"
            className={`border p-2 mb-2 block ${order.package_number && links[order.shipping_company] ? "w-5/6" : "w-full"}`}
            value={order.package_number || ""}
            onChange={(e) =>
              setOrder({ ...order, package_number: e.target.value })
            }
          />
          {order.package_number && links[order.shipping_company] ? (
            <span className="w-1/6 p-2 mb-2">
              <a href={`${links[order.shipping_company]}${order.package_number}`} target="_blank" rel="noopener noreferrer" className="float-right">
                <img src="../tracking.png" alt="Nyomkövetés" className="w-[32px]" />
              </a>
            </span>
          ) : null}

        </div>

        <div className="my-4">
          <label htmlFor="orderdate" className="block mb-2">Megrendelés dátuma</label>
          <input type="date"
            id="orderdate"
            className="border p-2 mb-2 block w-[90%]"
            value={order.order_date ? order.order_date.split("T")[0] : ""}
            onChange={(e) =>
              setOrder({ ...order, order_date: e.target.value || null })
            }
          >
          </input></div>

        {order.arrived &&
          <>
            <div className="my-4">
              <label htmlFor="completed_date" className="block mb-2">Megérkezés dátuma</label>
              <input type="date"
                id="completed_date"
                className="border p-2 mb-2 block w-[90%]"
                value={order.completed_date ? order.completed_date.split("T")[0] : ""}
                onChange={(e) =>
                  setOrder({ ...order, completed_date: e.target.value || null })
                }
              >
              </input>
            </div>
          </>
        }
        <div className="my-4">
          <label htmlFor="contributor" className="block mb-2">Közreműködő személy:</label>
          <select
            id='contributor'
            className="border p-2 mb-2 w-full"
            value={order.contributor_id || ""}
            onChange={(e) =>
              setOrder({ ...order, contributor_id: e.target.value || null })
            }
          >
            <option value="">-- Nincs megadva --</option>

            {
              users.map(user => {
                let canSelect = false;

                // Determine selection criteria
                if (role === "admin") {
                  // Admin can select any user except the order.user_id
                  canSelect = user.id !== order.user_id;
                } else if (order.contributor_id === self_id) {
                  // Only self can be selected if contributor is self
                  canSelect = user.id === self_id;
                } else if (order.user_id === self_id) {
                  // Allow all others except self if order.user_id is self
                  canSelect = user.id !== self_id;
                }

                if (canSelect) {
                  return (
                    <option key={user.id} value={user.id}>
                      {user.display_name}
                    </option>
                  );
                }
                return null; // Skip rendering options that do not meet the criteria
              })
            }
          </select>
        </div>

        <div className="my-4">
          <label htmlFor="description" className="block mb-2">Leírás:</label>
          <textarea
            id="description"
            className="border p-2 mb-2 w-full h-32"
            value={order.description || ""}
            onChange={(e) =>
              setOrder({ ...order, description: e.target.value })
            }
            placeholder="Megjegyzés a rendeléshez"
          />
        </div>

        <div className="my-4 flex justify-between">
          {order.completed_date ? (
            // Already has completed date
            <button
              className="bg-orange-500 text-white px-3 py-1 w-full"
              onClick={() => handleNotArrivedItem(order.id)} // Define this function for restoring the item
            >
              Mégsem érkezett meg
            </button>
          ) : (
            <button
              className="bg-green-500 text-white px-3 py-1 w-full"
              onClick={() => handleArrivedItem(order.id)}
            >
              Megérkezett
            </button>
          )}
        </div>
        {order.deleted ? (
          <>

            <div className="my-4 flex justify-between">
              <button
                className="bg-red-500 text-white px-3 py-1 w-full"
                onClick={() => handleFullDelete(order.id)} // Define this function for restoring the item
              >
                Végleges törlés
              </button>
            </div>
          </>
        ) : (
          <></>
        )}
        <div className="my-4 flex justify-between">
          <button
            className="bg-gray-300 text-black px-3 py-1"
            onClick={() => navigate("/")}
          >
            ← Vissza
          </button>
          <button
            className="bg-blue-500 text-white px-3 py-1 "
            onClick={save}
          >
            Mentés
          </button>
        </div>
      </div>
    </>);
}